import { Component, EventEmitter, Optional, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CompanyListComponent } from '../company-list/company-list.component';
import { Router } from '@angular/router';
import { postCompanyData, companyForm, companyType } from 'src/app/_model/company';
import { CompanyService } from 'src/app/_service/company.service';
import { MatIconRegistry } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { AuthService } from 'src/app/_service/auth.service';
import * as routing from 'src/app/_model/routing';
@Component({
  selector: 'app-company-edit',
  templateUrl: './company-edit.component.html',
  styleUrls: ['./company-edit.component.css']
})
export class CompanyEditComponent {
  @Output() dataChange = new EventEmitter();
  form = new companyForm;
  companyForm = this.form.defaultForm;
  editCompanyData!: postCompanyData;
  editMode = false;
  isSubmitting = false;

  companyTypes: companyType[] = [
    {value: 'typeOwner', display: 'owner'},
    {value: 'typeExOwner', display: 'exOwner'},
    {value: 'typeManagement', display: 'manager'},
    {value: 'typeExManagement', display: 'exManagement'},
    {value: 'typeBuilder', display: 'builder'},
    {value: 'typeManufacturer', display: 'manufacturer'},
    {value: 'typeMaintainer', display: 'maintainer'}
  ]
  constructor(
    private location: Location,
    private companyService: CompanyService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    @Optional() private dialogRef: MatDialogRef<CompanyListComponent>,
    public router: Router,
    public auth: AuthService,

  ) { 
    this.iconRegistry.addSvgIcon(
    'company',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/company.svg')
    );
    this.iconRegistry.addSvgIcon(
    'zoomin',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/zoomin.svg')
    );
    this.iconRegistry.addSvgIcon(
      'zoom',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/zoom.svg')
    );
  }

  ngOnInit(): void {
    if(this.companyService.editCompanyFlag){
      this.setEditCompanyData(this.companyService.editCompanyData);
      this.editMode = true;
    }else{
      this.editMode = false;
      this.companyForm.patchValue({types: []});
    }
  }

  ngOnDestroy(): void {
    this.companyService.resetSelectedCompanyID();
    this.companyService.resetEditCompany();
    this.companyForm.reset();
  }

  setEditCompanyData(editCompanyData: postCompanyData){
    this.companyForm.patchValue(editCompanyData);
  }
  
  onSubmit() {
    this.companyForm.get('types')?.setValue([]);
    // console.log(this.companyForm.value);
    if(this.auth.isYakuin){
      window.alert(this.translate.instant("noPermission"));
      return;
    }
    if(this.checkSubmit()){
      if(this.editMode){
        //update existing company
        this.companyService.submitExistingCompany(this.companyForm.value)
        .subscribe({
          error: (err) => {window.alert(this.translate.instant("err"));},
          complete: () => {
            window.alert(this.translate.instant("updated"));
            if (this.dialogRef) {
              this.dialogRef.close('changed');
            } else {
              this.router.navigate([`${routing.CompanyDetail}/${this.companyService.selectedCompanyID}`]);
            }
            this.companyForm.reset();
            this.dataChange.emit();
            this.companyService.companyListUpdate();
          
          }
        })
      }else{
        // console.log(this.types,this.companyForm.value)
        // register new company
        this.isSubmitting = true;
        this.companyService.submitNewCompany(this.companyForm.value)
        .subscribe({
          error: (err) => {
            window.alert(this.translate.instant("err"));
            this.isSubmitting = false;

          },
          complete: () => {
            window.alert(this.translate.instant("created"));
            this.companyForm.reset();
            this.isSubmitting= false;
            this.dataChange.emit();
          }
        })
      }
    }
  }
  
  onChange($event:any) {
    // console.log($event.target.value,$event.target.checked)
    let type = $event.target.value;
    let isChecked = $event.target.checked;
    this.companyForm.get(type)?.setValue(isChecked ? 1 : 0);
  }
  onClose(){
    this.companyService.editCompanyFlag = false;
    if (this.dialogRef) {
      this.dialogRef.close();
    } else {
      this.router.navigate([`${routing.CompanyDetail}/${this.companyService.selectedCompanyID}`]);
    }
  }
  checkSubmit() {
    if(window.confirm('Can I register this?')){
      return true;
    }else{
      //this.companyForm.get('types')?.setValue(this.types);
      return false;
    }
  }

  onDelete() {
    if (this.auth.isYakuin) {
      window.alert(this.translate.instant("noPermission"));
      return;
    }
    if (this.checkDelete()) {
      this.companyService.deleteCompanyData()
      .subscribe({
        error: () => {
          window.alert(this.translate.instant("err"));
        },
        complete: () => {
          window.alert(this.translate.instant("deleted"));
          if (this.dialogRef) {
            this.dialogRef.close('changed');
          } else {
            this.router.navigate([routing.CompanyList]);
          }
        }
      });
    }
  }

  onGlobalReadableChange($event: any) {
    this.companyForm.get('isGlobalReadable')?.setValue($event.target.checked);
  }

  checkDelete() {
    if (window.confirm('Are you sure you want to delete the company?')) {
      return true;
    } else {
      return false;
    }
  }

  goBack(){
    this.location.back();
  }
}
